import { render } from "./BestShadowTeam.vue?vue&type=template&id=4989d70d"
import script from "./BestShadowTeam.vue?vue&type=script&lang=js"
export * from "./BestShadowTeam.vue?vue&type=script&lang=js"

import "./BestShadowTeam.vue?vue&type=style&index=0&id=4989d70d&lang=css"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__